import { render, staticRenderFns } from "./ModelGenerator.vue?vue&type=template&id=738073e2"
import script from "./ModelGenerator.vue?vue&type=script&lang=js"
export * from "./ModelGenerator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports